import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { API } from './api';

@Injectable()
export class BrainBankProvider extends BaseProvider {
    constructor(private api: API) {
        super();
    }

    public async getBrainBankVersion(): Promise<string> {
        const result = await this.api.get('version');

        return result.message.version;
    }
}



// WEBPACK FOOTER //
// ./src/providers/brainbank.ts